// ============================================
// SELECTORIVA.JS — Toggle compartido "Con IVA / Sin IVA" + hook useIvaModo
// ============================================
// Estado compartido en localStorage 'beep_iva_modo' (valores 'con'|'sin',
// default 'con') + CustomEvent 'beep-iva-changed' para sincronizar todas las
// pantallas (La Tienda y el editor de cotizacion). El switch SOLO afecta lo que
// se MUESTRA; los precios se SIGUEN guardando SIN IVA.

import React, { useEffect, useState } from 'react';
import { PP, COLOR_OSCURO, COLOR_GRIS, COLOR_BORDE } from './helpersClientes';
// IVA centralizado (fuente unica).
import { TASA_IVA } from '../config/iva';

const STORAGE_KEY = 'beep_iva_modo';
const EVENT_NAME = 'beep-iva-changed';
const IVA = TASA_IVA;

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export function leerIvaModo() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'sin' ? 'sin' : 'con';
  } catch { return 'con'; }
}

export function setIvaModoGlobal(modo) {
  const v = modo === 'sin' ? 'sin' : 'con';
  try { localStorage.setItem(STORAGE_KEY, v); } catch {}
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { modo: v } }));
}

// Aplica IVA al MOSTRAR: con -> monto*1.16; sin -> monto tal cual. Redondeo a 2.
export function conIvaSegun(modo, monto) {
  return modo === 'con' ? round2((Number(monto) || 0) * (1 + IVA)) : round2(Number(monto) || 0);
}

// Inverso: de un valor MOSTRADO con IVA al valor interno SIN IVA (para el campo
// editable de precio). con -> monto/1.16; sin -> monto tal cual. Redondeo a 2.
export function quitarIvaSegun(modo, monto) {
  return modo === 'con' ? round2((Number(monto) || 0) / (1 + IVA)) : round2(Number(monto) || 0);
}

// Hook: modo actual + setter global. Se re-sincroniza con el evento y con cambios
// desde otra pestana (storage).
export function useIvaModo() {
  const [modo, setModo] = useState(leerIvaModo());
  useEffect(() => {
    const onChange = (e) => setModo(e?.detail?.modo || leerIvaModo());
    window.addEventListener(EVENT_NAME, onChange);
    const onStorage = (e) => { if (e.key === STORAGE_KEY) setModo(leerIvaModo()); };
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(EVENT_NAME, onChange);
      window.removeEventListener('storage', onStorage);
    };
  }, []);
  return [modo, setIvaModoGlobal];
}

// Toggle visual estilo MXN/USD (pill de dos botones).
export function ToggleIva({ modo, onCambio, compacto = false }) {
  const btn = (val) => ({
    padding: compacto ? '4px 10px' : '6px 14px',
    fontSize: compacto ? 11 : 12,
    fontWeight: 700,
    fontFamily: PP,
    cursor: 'pointer',
    border: 'none',
    background: modo === val ? COLOR_OSCURO : 'transparent',
    color: modo === val ? '#fff' : COLOR_GRIS,
    transition: 'all 0.15s',
    minHeight: 44,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    whiteSpace: 'nowrap',
  });
  return (
    <div style={{
      display: 'inline-flex',
      border: `1px solid ${COLOR_BORDE}`,
      borderRadius: 99,
      overflow: 'hidden',
      background: '#fff',
    }}>
      <button type="button" style={{ ...btn('con'), borderRadius: '99px 0 0 99px' }} onClick={() => onCambio('con')}>Con IVA</button>
      <button type="button" style={{ ...btn('sin'), borderRadius: '0 99px 99px 0' }} onClick={() => onCambio('sin')}>Sin IVA</button>
    </div>
  );
}
